/* eslint-disable max-len, max-lines */
import {getContent, getPatchNote, type PatchNote, type PatchNoteContent, PatchNoteType} from './UIPatchNoteModule.ts'
// import AnnouncementColonistTournament from '@static/images/announcement_colonist_tournament.png'
// import AnnouncementGift from '@static/images/announcement_gift.png'
// import DangFixPixelatedFullscreenPopupImageBefore from '@static/images/patch_notes_images/dang-fix-pixelated-fullscreen-popup-image-before.png'
// import DangFixPixelatedFullscreenPopupImageAfter from '@static/images/patch_notes_images/dang-fix-pixelated-fullscreen-popup-image-after.png'
// import DangUpdatePaymentSuccessfulPopupBefore from '@static/images/patch_notes_images/dang-update-payment-successful-popup-before.png'
// import DangUpdatePaymentSuccessfulPopupAfter from '@static/images/patch_notes_images/dang-update-payment-successful-popup-after.png'

// import StanFixSafariLowResolutionDiceBefore from '@static/images/patch_notes_images/stan-fix-safari-low-resolution-dice-before.jpg'
// import StanFixSafariLowResolutionDiceAfter from '@static/images/patch_notes_images/stan-fix-safari-low-resolution-dice-after.jpg'
// import MuhammadRenameLobbyToRoomsBefore from '@static/images/patch_notes_images/rename-lobby-to-rooms-before.png'
// import MuhammadRenameLobbyToRoomsAfter from '@static/images/patch_notes_images/rename-lobby-to-rooms-after.png'
// import MuhammadFixUsernameAvatarNotShowingInChatBefore from '@static/images/patch_notes_images/message-appears-without-username-avatar-before.png'
// import MuhammadFixUsernameAvatarNotShowingInChatAfter from '@static/images/patch_notes_images/message-appears-without-username-avatar-after.png'

export class PatchNoteData {
    protected readonly patchNotes: PatchNote[]
    protected readonly announcement: string[]

    constructor() {
        this.patchNotes = []
        this.announcement = []

        this.announcement.push('<b>Join this weekend\'s Colonist Championship 2026 qualifier. <a href="https://tinyurl.com/colonist4ptourney55" target="_blank">Register here</a></b>')
        // this.announcement.push(`<a href="/championship" target="_blank"><img src="${AnnouncementColonistTournament}" style="width: 100%"></a>`)
        // this.announcement.push(`<a href="https://www.youtube.com/@colonistio/?sub_confirmation=1" target="_blank"><img src="${AnnouncementColonistCon24}" style="width: 100%"></a>`)
        // this.announcement.push('Check out our latest video! </b><a href="https://youtu.be/R_hl_CAefrg" target="_blank">1 v 1 Guide!</a>!</b>')
        // this.announcement.push('<iframe style="display: block; margin: 0 auto;" width="560" height="315" src="https://www.youtube.com/embed/xtkDDYhfMHw?si=CugURvk5342Fyj02" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>')
        // this.announcement.push('<b>We are looking for a Community Manager. Check out <a href="/careers" target="_blank">careers</a>!</b>')
        // this.announcement.push(`<a href="https://blog.colonist.io/colonist-io-2023-summary/"><img src="${Announcement2023YearlyStats}" style="width: 100%"></a>`)
        // this.announcement.push(`<a href="/store#gift"><img src="/${AnnouncementGift}" style="width: 100%"></a>`)

        // Jeff

        // Andre

        // Rob

        // Oguz

        // Muhammad

        // Marc

        // Dang

        // Mo

        // Ali

        // Hassan

        // Sinan

        // Efe

        // Nesir

        // ! PUBLIC PN FORMAT: v298.push(getContent(PatchNoteType.xxx, 'Description', ['Thanks to'], '/v298/before-image.png', '/v298/after-image.png', ['FeatureUpvote link']))

        const v300: PatchNoteContent[] = []
        v300.push(getContent(PatchNoteType.Update, 'Improved tile highlights', undefined, '/v299/tile_highlights_before.png', '/v299/tile_highlights_after.png'))
        v300.push(getContent(PatchNoteType.Update, 'Updated sidebar on smaller screens', undefined, '/v300/new-web-sidebar-before.png', '/v300/new-web-sidebar-after.png'))
        v300.push(getContent(PatchNoteType.Update, 'Added Hard Bot difficulty to rooms', undefined, '/v300/hard-bot-before.png', '/v300/hard-bot-after.png', ['https://colonist.featureupvote.com/suggestions/629880/create-option-for-hard-bots-in-create-room-not-just-single-player']))
        v300.push(getContent(PatchNoteType.Update, '[Mobile] Updated in-game floating text confirmation', undefined, '/v299/floating-text-pill-style-before.png', '/v299/floating-text-pill-style-after.png'))

        // Muhammad
        // update mode selector timers to update on better intervals (not every second)
        // fix storybook not loading on local
        // add @vitest/ui to run vitest ui mode
        // fix mountUIReactComponent not enforcing prop types
        // more page - add careers notification
        // remove sourcemap from production builds

        // Marc
        // Update monthly revenue report workflow to get gross revenue (gift + credit notes)
        // Update Product Management docs to include project ownership

        // Dang
        // Mobile - Update mobile_rn dependencies and increment build number
        // Show portrait mode opt-in popup for mobile app users who are still playing in Landscape mode
        // React Refactor - Build RankedTable component

        // Mo
        // fix resume button showing for spectators in pause overlay

        // Sinan
        // Fix FAQ page not loading on Discord
        // React Refactor - add muted variant and small size to Button component
        // React Refactor - create @colonist/consts package for shared constants
        // React Refactor - build IconButton component

        // Nesir
        // Replaced old lobby room icons

        this.patchNotes.push(getPatchNote(2026, 4, 14, 300, v300))

        const v299: PatchNoteContent[] = []
        v299.push(getContent(PatchNoteType.Update, '[Web/Discord] New More page', undefined, '/v299/web-more-page-before.png', '/v299/web-more-page-after.png'))
        v299.push(getContent(PatchNoteType.Update, '[Web/Discord] Moved Profile page to header', undefined, '/v299/profile-page-before.png', '/v299/profile-page-after.png'))
        v299.push(getContent(PatchNoteType.Update, 'Updated mode selector styles', undefined, '/v299/tab-slide-before.gif', '/v299/tab-slide-after.gif'))
        v299.push(getContent(PatchNoteType.Update, 'Increased player username font size for better readability', undefined, '/v299/username-before.png', '/v299/username-after.png'))
        v299.push(getContent(PatchNoteType.Update, '[Mobile] Removed transparency from owned cards container on portrait mode', undefined, '/v299/card-container-transparency-before.png', '/v299/card-container-transparency-after.png'))
        v299.push(getContent(PatchNoteType.Fix, '[Mobile] Fix notification panel links not working'))
        v299.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed iOS context menu appearing when holding down images', undefined, '/v299/ios-context-menu-before.png'))

        // Muhammad
        // update new login screens to match design; fix layout issues
        // update stylelint command to catch all scss files
        // fix web more page to match designs

        // Marc
        // Add new GitHub workflow to post monthly revenue report to Discord automatically

        // Sinan
        // Fix hiding Helply widget when navigated away from FAQ page
        // React Refactor - Create common TextInput component

        // Efe
        // Update Helply support widget trigger button colors to white background with blue icon

        this.patchNotes.push(getPatchNote(2026, 4, 7, 299, v299))

        const v298: PatchNoteContent[] = []
        v298.push(getContent(PatchNoteType.Update, 'Decreased Ranked matchmaking times by 33%'))
        v298.push(getContent(PatchNoteType.Update, '[Mobile] Tapping outside the information overlay now closes it'))
        v298.push(getContent(PatchNoteType.Update, '[Mobile] Redesigned login screen', undefined, '/v298/mobile-login-before.png', '/v298/mobile-login-after.png'))
        v298.push(getContent(PatchNoteType.Update, '[Web] Redesigned login popup', undefined, '/v298/web-login-popup-before.png', '/v298/web-login-popup-after.png'))
        v298.push(getContent(PatchNoteType.Update, 'Moved Cities & Knights before Seafarers in the room Game Mode list', undefined, '/v298/game-mode-reorder-before.png', '/v298/game-mode-reorder-after.png'))
        v298.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed VP counts being too small in 2-3 player games', undefined, '/v298/2-3p-mobile-ui-before.png', '/v298/2-3p-mobile-ui-after.png'))
        v298.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed some buttons staying darkened on tap', undefined, '/v297/fix-hover-before.png', '/v297/fix-hover-after.png'))
        v298.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed blog page not opening in iOS browsers'))
        v298.push(getContent(PatchNoteType.Fix, 'Fixed Colonist Championship 2026 form pages not opening on mobile'))
        v298.push(getContent(PatchNoteType.Fix, 'Fixed country flags not showing in the end game screen after Ranked games', undefined, '/v298/endgame-flag-before.png', '/v298/endgame-flag-after.png'))
        v298.push(getContent(PatchNoteType.Fix, 'Fixed mobile view rejecting clicks in non-mobile browsers'))
        v298.push(getContent(PatchNoteType.Fix, 'Fixed bank trades requiring individual card clicks in private lobby 1v1 games'))
        v298.push(getContent(PatchNoteType.Fix, '[Rush] Fixed dice roll sound not playing when the same number is rolled consecutively'))

        // Juan
        // LR and LA counters turn bold when the achievement is unlocked

        // Muhammad
        // More page - use global context
        // move react global context
        // More page - add 2col layout
        // move clientuserstate out of package
        // update /address-pr-comments skill to read images in pr
        // add react/react-dom to package.json to move initial renders out of packages
        // fix uigameplayerinfo stories
        // move code/eslints to a single folder

        // Marc
        // New vscode setting that automatically adds file extensions to imported files
        // Fix flaky UserReferralController mocha test
        // Add App as possible platform in frontend changes PR template

        // Dang
        // React Refactor - Build Table common component
        // React Refactor - Decouple FetchMoreContainer and StickyRowTable from Table

        this.patchNotes.push(getPatchNote(2026, 3, 31, 298, v298))

        const v297: PatchNoteContent[] = []
        v297.push(getContent(PatchNoteType.Update, '[Mobile] New More page', undefined, '/v297/more-page-before.png', '/v297/more-page-after.png'))
        v297.push(getContent(PatchNoteType.Update, '[Mobile] Moved opening the profile page to the header', undefined, '/v297/move-profile-page-before.png', '/v297/move-profile-page-after.png'))
        v297.push(getContent(PatchNoteType.Fix, 'Fixed the game state revealing what card a player was about to play before they confirmed its use'))
        v297.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed dice and building buttons being covered by the Chat/Logs panel', undefined, '/v297/chat-dice-overlap-before', '/v297/chat-dice-overlap-after'))
        v297.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed timer being shown on all replay actions'))
        v297.push(getContent(PatchNoteType.Fix, 'Fixed Edit Trade icon appearing as disabled', undefined, '/v297/fix-pencil-icon-before.png', '/v297/fix-pencil-icon-after.png'))
        v297.push(getContent(PatchNoteType.Fix, 'Logging in from a room now redirects back to the room instead of the homepage'))

        // Oguz
        // Fixed ranked rush queue visual in details page, and updated the card to match the other cards
        // Set friendly robber and balanced dice for Rush ranked queue

        // Muhammad
        // More page 1 - allow no selected mobile scene
        // More page 2 - improve mobile scrolling
        // fix game state export
        // update spacing in mobile search view

        // Marc
        // Add /deleteshufflequeuebyid command to delete a shuffle queue by id

        // Dang
        // [Mobile Web] Portrait mode opt-in popup for mobile web users
        // Fix project configs and typings for FeedMessageData
        // React Refactor - Build React Global UI Context (UIGlobalContext)
        // React Refactor - Refactor ClientUserState to use UserStateStore in Game's code

        // Hassan
        // move translation note from onboarding to translation_pipeline doc
        // [Mobile] Update title to leaderboards
        // v297.push(getContent(PatchNoteType.Fix, 'Fixed profile not updating after changing username until page refresh'))
        // v296.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed invite friends list not being scrollable when more than 4-5 friends are online'))
        // update dev level 2 doc links
        // v297.push(getContent(PatchNoteType.Update, 'Updated login buttons and popup login UI'))
        // v298.push(getContent(PatchNoteType.Update, 'Redesigned login screens', undefined, '/v298/login-redesign-before.png', '/v298/login-redesign-after.png'))

        // Sinan
        // React Refactor - Build SearchPlayer component
        // Added docs for ai security best practices
        // React Refactor - Integrate SearchPlayer to Leaderboard page
        // React Refactor - Integrate PageTabs component to Leaderboard page
        // Fixed mobile view was rejecting clicks in non-mobile browsers

        this.patchNotes.push(getPatchNote(2026, 3, 24, 297, v297))

        const v296: PatchNoteContent[] = []
        v296.push(getContent(PatchNoteType.Update, 'New homepage card design', undefined, '/v294/new_homepage_cards_before.png', '/v294/new_homepage_cards_after.png'))
        v296.push(getContent(PatchNoteType.Update, 'Updated menu icons', undefined, '/v296/new-menu-icons-before.png', '/v296/new-menu-icons-after.png'))
        v296.push(getContent(PatchNoteType.Fix, 'Fixed toast notification text not being vertically aligned with icons', undefined, '/v296/toast-vertical-align-before.png', '/v296/toast-vertical-align-after.png'))
        v296.push(getContent(PatchNoteType.Fix, 'Fixed \'Disable Karma\' button being enabled when karma is already disabled'))
        v296.push(getContent(PatchNoteType.Fix, 'Fixed player information layout on tablets', undefined, '/v296/tablet-layout-old.png', '/v296/tablet-layout-new.png'))
        v296.push(getContent(PatchNoteType.Fix, 'Improved visibility of player information in 1v1 and 3-player mobile games', undefined, '/v296/1v1-old.png', '/v296/1v1-new.png'))

        // Oguz
        // Add ranked Colonist Rush 4P queue, matchmaking, and leaderboard tab as a Season 16 beta, gated behind RANKED_RUSH_4P A/B test

        // Muhammad
        // build more page components
        // React Refactor - Integrate TableTabs component to Leaderboard page
        // add docs for ai development & tooling
        // update ai and dev docs

        // Marc
        // Move rewards section to second position in store sidebar and update icon
        // Show referral program lobby ad on web
        // Change node version to 22 in docs

        // Dang
        // React Refactor - Build CountryFlag component
        // React Refactor - Build ClientUserState React wrapper
        // React Refactor - Build PageTabs component

        // Mo

        // Ali

        this.patchNotes.push(getPatchNote(2026, 3, 17, 296, v296))

        const v295: PatchNoteContent[] = []
        v295.push(getContent(PatchNoteType.Feature, 'Invite friends and get rewards! Unlock maps, expansions, and Memberships. Visit the <a href="/store" target="_blank">Store</a> to learn more'))
        v295.push(getContent(PatchNoteType.Update, '[Mobile] Redesigned in-game player information', undefined, '/v295/portrait-player-info-before.png', '/v295/portrait-player-info-new.gif'))
        v295.push(getContent(PatchNoteType.Update, 'Show spectator usernames instead of only the spectator count', undefined, undefined, undefined, ['https://colonist.featureupvote.com/suggestions/212265/spectator-name-list']))
        v295.push(getContent(PatchNoteType.Update, 'Update default room speed to 60s'))
        v295.push(getContent(PatchNoteType.Update, 'Updated game mode icons', undefined, '/v295/new_game_mode_icons_before.gif', '/v295/new_game_mode_icons_after.gif'))
        v295.push(getContent(PatchNoteType.Update, 'Enlarged checkout button on web store for better visibility', undefined, '/v295/checkout_button_before.png', '/v295/checkout_button_after.png'))
        v295.push(getContent(PatchNoteType.Update, 'Volume level after un-muting is restored to the previous level'))
        v295.push(getContent(PatchNoteType.Update, '[Tablet] Added share game results icon to end game screen'))
        v295.push(getContent(PatchNoteType.Fix, '[Tablet] Fixed store popup color piece images not being centered', undefined, '/v295/store_popup_tablet_before.png', '/v295/store_popup_tablet_after.png'))

        // Muhammad
        // apply new paddings on text elements
        // React Refactor - Build TableTabs component

        // Marc
        // Change var type from const to TranslationObject

        this.patchNotes.push(getPatchNote(2026, 3, 10, 295, v295))

        const v294: PatchNoteContent[] = []
        v294.push(getContent(PatchNoteType.Fix, 'Minor bug fixes and internal improvements'))
        v294.push(getContent(PatchNoteType.Fix, 'Enhanced platform stability'))

        // Oguz
        // Remove Colonist Rush Bot Game Tab CTA AB Test
        // Removed Colonist Rush Beta tag

        // Marc
        // Mobile - Add replay url share button on share results popup
        // update link to colonist in-game commands in docs
        // exclude gold tile maps from Rush mode shuffle queues
        // handle new error code 50278 from Discord API

        // Dang
        // React Refactor - Build React SeasonProgress component
        // Fix CI failed tests due to visitor table partitions
        // Fix CI failed tests due to Catan Universe online count API

        this.patchNotes.push(getPatchNote(2026, 3, 3, 294, v294))

        const v293: PatchNoteContent[] = []
        v293.push(getContent(PatchNoteType.Update, 'Added a notification to inform users when they are muted for abusing chat', undefined, undefined, undefined))
        v293.push(getContent(PatchNoteType.Update, 'Increased Shuffle Rush turn timer from 5s to 10s'))
        v293.push(getContent(PatchNoteType.Update, 'Improved page scrolling', undefined, '/v293/page_scrolling_before.png', '/v293/page_scrolling_after.png'))
        v293.push(getContent(PatchNoteType.Update, 'New Leaderboards icon', undefined, '/v293/new_leaderboard_icon_before.png', '/v293/new_leaderboard_icon_after.png'))
        v293.push(getContent(PatchNoteType.Fix, 'Fixed reconnect banner not showing on some pages'))

        // Rob
        // Make Shuffle Queue and Setting tables visible in Colonist-Limited on Metabase
        // Prevent banned users from deleting their accounts
        // Fixed HTML tag in content_terms_of_service.ejs
        // Add Metabase Query Agent to docs
        // Mobile Player Info Views - Toggle states persist across sessions

        // Stan
        // Set CODEOWNERS package.json and webpack.config.ts to @rgsthethird (previously @StanFlint)

        // Muhammad
        // remove shuffle banners (marketing test over)
        // update web sidebar & mobile bottom nav leaderboard icon
        // update profilepage banner to become a member
        // update padding and scrolling on singleton pages
        // update design tool assets doc to use 64x64px square icons
        // update careers page hero section
        // shuffle rush speed from 5s to 10s
        // add backend game count check for shuffle queue eligibility

        // Marc
        // fix leaderboard scrolling

        // Dang
        // React Refactor - Move Dialog component to Shared React UI package
        // React Refactor - Move Dropdown component to Shared React UI package
        // React Refactor - Move Button component to Shared React UI package
        // React Refactor - Move Tooltip component to Shared React UI package
        // React Refactor - Build React SeasonProgress component
        // React Refactor - Integrate new SeasonProgress component to Leaderboard page

        // Devyesh
        // [Mobile] Implement auto-deploy apps workflow

        // Ali
        // [Web] Enlarged checkout button for better visibility - PLA-406

        this.patchNotes.push(getPatchNote(2026, 2, 24, 293, v293))

        const v292: PatchNoteContent[] = []
        v292.push(getContent(PatchNoteType.Update, '[Mobile] Info popup can now be accessed straight from the header', undefined, '/v292/portrait_new_top_bar_before.png', '/v292/portrait_new_top_bar_after.png'))

        // Oguz
        // Replace Bot Game Tab CTA AB Test with v2

        // Marc
        // Add on mobile the possibility to share game results on game end screen
        // Add shuffle banners back
        // Fix padding on mobile for mode/map selector cards
        // v291.push(getContent(PatchNoteType.Fix, '[Web] Fixed bug where user could not accept game invite from notification panel'))

        // Dang
        // React Refactor - Set up common styles for @colonist/ui package
        // React Refactor - Move Spinner component to Shared React UI package
        // Setup new starting packages folders for React Refactor

        // Efe
        // Tweak notification badge spacing in header so blue dot doesn’t touch sidebar

        this.patchNotes.push(getPatchNote(2026, 2, 17, 292, v292))

        const v291: PatchNoteContent[] = []
        v291.push(getContent(PatchNoteType.Blog, 'Colonist 2025 Summary! <a href="https://blog.colonist.io/colonist-io-2025-summary/" target="_blank">Read here!</a>', undefined, undefined, undefined, ['https://blog.colonist.io/colonist-io-2025-summary/']))

        // Jeff
        // Cleaned up SeasonPlayerEntityService.refreshSeason to avoid hard coded elo types.

        // Rob
        // Make Shuffle Queue and Setting tables visible in Colonist-Limited on Metabase
        // Prevent banned users from deleting their accounts
        // Fixed HTML tag in content_terms_of_service.ejs

        // Muhammad
        // rename standard -> base on shuffle card
        // fix padding on mode selector badge

        // Marc
        // Fix padding on I'm Ready checkbox in room
        // Fix padding on Become a Member popup

        this.patchNotes.push(getPatchNote(2026, 2, 10, 291, v291))

        const v290: PatchNoteContent[] = []
        v290.push(getContent(PatchNoteType.Update, 'Colonist Rush Free Beta period has ended', undefined, undefined, undefined))

        // Jeff
        // Block banned users from seeing replay data
        // Added framework to handle game state migrations. No migrations added yet.

        // Rob
        // Make Shuffle Queue and Setting tables visible in Colonist-Limited on Metabase

        // Oguz
        // Fixed /banmostreportedplayers command punishing players for the same offence multiple times

        // Marc
        // Update Shuffle Queue Rush play time to 10 minutes

        // Dang
        // v290.push(getContent(PatchNoteType.Fix, '[Discord Mobile] Fix issue unable to click I\'m Ready button', undefined, undefined, undefined))
        // React Refactor - Move and Refactor Storybook to apps/storybook
        // React Refactor - Move T component to Shared React UI package
        // Setup new starting packages folders for React Refactor
        // Fix failing CI tests
        // Fix IOS broken when MobileEnableNativePayments is enabled

        this.patchNotes.push(getPatchNote(2026, 2, 4, 290, v290))

        // Efe
        // Removed rounded corners from the right sidebar menu (Rules, FAQ, etc.)

        // Efe
        // Updated Rules sidebar: consistent hover style and no unique background on first item

        const v289: PatchNoteContent[] = []

        v289.push(getContent(PatchNoteType.Update, '<a href="/championship2026" target="_blank">Colonist Championship 2026</a> is confirmed! More details coming this April!'))
        v289.push(getContent(PatchNoteType.Update, 'Updated payment successful popup UI', undefined, '/v289/update_payment_successful_popup_before.png', '/v289/update_payment_successful_popup_after.png'))
        v289.push(getContent(PatchNoteType.Update, 'Grouped the unlocked maps & game modes together', undefined, '/v289/group_owned_maps_before.png', '/v289/group_owned_maps_after.png'))
        v289.push(getContent(PatchNoteType.Update, '"Lobby" is now called "Rooms"', undefined, '/v289/rename_lobby_to_room_before.png', '/v289/rename_lobby_to_room_after.png'))
        v289.push(getContent(PatchNoteType.Fix, 'Fixed username/icon not showing in chat sometimes', undefined, '/v289/message_appears_without_username_avatar_before.png', '/v289/message_appears_without_username_avatar_after.png'))
        v289.push(getContent(PatchNoteType.Fix, 'Fixed pixelated fullscreen popup image', undefined, '/v289/fix_pixelated_fullscreen_popup_before.png', '/v289/fix_pixelated_fullscreen_popup_after.png'))

        // Oguz
        // Update mute punishment column types to match the production database, and fix max mute amount to be 999

        // Muhammad
        // remove team values doc; now on /values page
        // move team values examples doc to /values-examples page
        // use new badge components across the app
        // refactor codebase from $padding-x & magic numbers to $space-x
        // fix badges on cc26 page

        // Marc
        // Remove AB Test to reactivate Discord inactive users

        // Dang
        // Sort Rush mode rooms to the top of Lobby room list
        // v289.push(getContent(PatchNoteType.Fix, 'Fixed pixelated fullscreen popup image', undefined, DangFixPixelatedFullscreenPopupImageBefore, DangFixPixelatedFullscreenPopupImageAfter))
        // v288.push(getContent(PatchNoteType.Update, 'Update payment successful popup UI', undefined, DangUpdatePaymentSuccessfulPopupBefore, DangUpdatePaymentSuccessfulPopupAfter))

        // Devyesh
        // Fixing loading on mobile, test servers

        // William
        // Added spinner to patch note image popup

        this.patchNotes.push(getPatchNote(2026, 1, 27, 289, v289))

        const v288: PatchNoteContent[] = []

        v288.push(getContent(PatchNoteType.Update, 'Added 15s turn timer setting and removed 240s turn timer setting from rooms', undefined, undefined, undefined))
        v288.push(getContent(PatchNoteType.Fix, '[Rush] Fixed road building error message showing for the wrong player', undefined, undefined, undefined))
        v288.push(getContent(PatchNoteType.Fix, 'Fixed "New" badge always showing for logged in users', undefined, '/v288/new_badge_before.png', '/v288/new_badge_after.png'))
        v288.push(getContent(PatchNoteType.Fix, 'Submitting a trade no longer closes the trade panel'))
        v288.push(getContent(PatchNoteType.Fix, 'Fixed not being able to re-enter fullscreen after exiting with ESC key'))

        // Oguz
        // Created A/B Test for Colonist Rush in bot games tab

        // Stan
        // [Discord Mobile] Fixed assets not loading in portrait mode
        // Add analytic event for getReplayDataFromGameId API call

        // Muhammad
        // exclude earth and uk maps from shuffle queue if not seafarers mode
        // remove mobile push notification room commands
        // change shuffle rush time to 5s and discard limit to 9

        // Marc
        // Add referral program on Web and Mobile (AB tested)

        // Dang
        // Add /toggleabtest chat command to toggle global AB tests
        // v288.push(getContent(PatchNoteType.Fix, 'Submitting a trade no longer closes the trade panel'))
        // v288.push(getContent(PatchNoteType.Fix, 'Fixed not being able to re-enter fullscreen after exiting with ESC key'))

        // Devyesh
        // Referral type enums renamed (DB migration)

        // Andrew
        // Update adblock popups wording

        this.patchNotes.push(getPatchNote(2026, 1, 20, 288, v288))

        const v287: PatchNoteContent[] = []

        v287.push(getContent(PatchNoteType.Update, 'Colonist Championship 2025 is over! Check the results in the <a href="/championship2025" target="_blank">CC25 page</a>!'))
        v287.push(getContent(PatchNoteType.Update, 'Clicking "Play Again" after a bot game immediately starts a new game, instead of creating a lobby'))
        v287.push(getContent(PatchNoteType.Update, '[Mobile] Slightly increased Game End screen button and text sizes', undefined, '/v287/mobile_endgame_before.png', '/v287/mobile_endgame_after.png'))
        v287.push(getContent(PatchNoteType.Fix, 'Fixed game counts to unlock Ranked'))
        v287.push(getContent(PatchNoteType.Fix, 'Fixed low resolution dice on iPhone/Mac', undefined, '/v287/ios_dice_resolution_before.png', '/v287/ios_dice_resolution_after.png'))

        // Stan
        // [Discord] Added feature flag to set the orientation of the Discord Embedded Activity SDK
        // Add more details to discard invalid cards internal logs
        // Make rush5s the default speed setting for rush mode

        // Muhammad
        // fix slow loading for casual/ranked cards for logged out users
        // update shuffle mode details page
        // remove membership banner ad from mobile mainpage
        // update details page margins
        // add bot game option when making a shuffle queue

        // Dang
        // Fix missing linking account error popup
        // Add 1 second delay to matchmaking requests

        // Devyesh
        // [Mobile] Upgraded the IAP version
        // [Mobile] Added support for IAP for Coins and Gifts in Android
        // ]Mobile] Added support fot IAP for Memberships in Android
        // [Mobile] Add support to test IAP for internal users

        this.patchNotes.push(getPatchNote(2026, 1, 13, 287, v287))

        const v286: PatchNoteContent[] = []

        v286.push(getContent(PatchNoteType.Update, '[Colonist Rush] Updated the default speed setting in rooms to 10s', undefined, undefined, undefined))
        v286.push(getContent(PatchNoteType.Update, 'Removed confirmation popup when kicking a bot from lobby', undefined, '/v286/bot_kick_confirmation_before.png', undefined))
        v286.push(getContent(PatchNoteType.Update, 'Simplify slider text for guests', undefined, '/v286/room_guests_before.png', '/v286/room_guests_after.png'))

        // Jeff
        // Update rematch database game type so it gets tagged correctly as a "CreateRoomGame"

        // Rob
        // HOTFIX: Allow users to CK dice roll after using dice roll free play

        // Muhammad
        // remove mobile become a member banner ab test (always show)
        // remove landing page header ab test
        // Added shuffle queue bias for 6&8 player modes and gold/fog maps

        this.patchNotes.push(getPatchNote(2026, 1, 6, 286, v286))

        const v285: PatchNoteContent[] = []
        v285.push(getContent(PatchNoteType.Fix, 'Fixed game-breaking bug when using Road Building with only one road left in Rush', undefined, undefined, undefined))

        // Juan
        // Added CC25 winner profile badge

        // Marc
        // Track performance of mobile push notification used for reactivation

        // Dang
        // Fix whole page broken for returning users who have not logged in for 30 days
        // [Mobile] Implement A/B test for mobile my turn push notification

        this.patchNotes.push(getPatchNote(2025, 12, 30, 285, v285))

        const v284: PatchNoteContent[] = []
        v284.push(getContent(PatchNoteType.Fix, 'Fixed inverted order of resource cards on trade counter offers created by current player', undefined, '/v284/trade_counter_offer_before.png', '/v284/trade_counter_offer_after.png'))
        v284.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed status bar appearing unexpectedly on some Android devices', undefined, '/v284/android_status_bar_before.png', '/v284/android_status_bar_after.png'))
        v284.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed counter offer panel extending beyond screen with 8 players', undefined, '/v284/counter_offer_8p_before.png', '/v284/counter_offer_8p_after.png'))
        v284.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed outdated C&K City Improvement colors in player info boxes', undefined, '/v284/city_improvement_mobile_before.png', '/v284/city_improvement_mobile_after.png'))

        // Rob
        // HOTFIX: Error handling for service worker caching
        // CK Monetization Test v3: 5 Free Plays/Dice Rolls

        // Oguz
        // Refactored auto-mute system to use an easier curve for calculating the number of games to mute, good behavior over time is rewarded, and /unmute command now deletes all mute entries.

        // Muhammad
        // fix ads not showing on hexs.io
        // hide external lobby ads for users who have played less than 5 games (shows private ads instead)

        this.patchNotes.push(getPatchNote(2025, 12, 23, 284, v284))

        const v283: PatchNoteContent[] = []
        v283.push(getContent(PatchNoteType.Update, '[Mobile] Achievement popup is below player information container', undefined, '/v283/stop-achievements-blocking-before.png', '/v283/stop-achievements-blocking-after.png'))
        v283.push(getContent(PatchNoteType.Update, 'Updated Shuffle mode card UI', undefined, '/v283/shuffle_card_before.png', '/v283/shuffle_card_after.png'))
        v283.push(getContent(PatchNoteType.Fix, 'Fixed shifting content when switching between tabs', undefined, '/v283/shifting_content_before.png', '/v283/shifting_content_after.png'))
        v283.push(getContent(PatchNoteType.Fix, 'Fixed inconsistent gaps between chat, logs, and bank containers'))

        // Rob
        // Shuffle 1v1 games have 15 VPs

        // Oguz
        // Made map corners and edges clickable even when the action is not available on mobile
        // Removed Bot Speed from in-game settings page and from profile game history
        // Renamed GameSpeedSettings enum values to match new turn timer settings
        // Added allowedGameTimers to GameModeData and the GameTimerOption interface
        // v283.push(getContent(PatchNoteType.Fix, 'Fixed the inverted trade resources in counter offers created by the current turn player', undefined, undefined, undefined))

        // Stan
        // [Rush] Fixed trade creator offered cards not updating after monopoly card usage
        // Achievement popup click to dismiss
        // Hide the end screen replay share button in portrait if no replay is available
        // Remove unused UIGameAvatarWithCards component (leftover from ReactJS refactor)
        // [Rush] Replaced "Alpha" with "Beta" branding
        // [Rush] Increased visibility of Rush map bottom logo

        // Muhammad
        // update shuffle queue free games badge
        // remove icons from landing page social proof
        // select mode selector card from matchmaking queue url parameter
        // update language button ui in mobile menu and add to web
        // updated design for mode selector tabs
        // fix bot section briefly showing before localstorage is loaded
        // move shuffle data out of clientuserstate

        // Dang
        // [Mobile] Update annual membership prices for Android
        // Move redirection logic for old account from client to server
        // Fix city improvement tracker icon size and alignment in action button
        // [Mobile Web] Fix Rulebook redirection for Guest user
        // [Mobile] Force portrait mode for returning mobile app players whose last session was more than 30 days ago
        // [Mobile] Fix counter-offer UI goes off-screen in 8-player games

        // Devyesh

        // Sinan
        // v283.push(getContent(PatchNoteType.Update, 'Membership plan pricing tab UI updated to take the full width', undefined, 'https://imgur.com/a/DBl9EjE', 'https://imgur.com/a/2mAYODe'))

        // ! PUBLIC PN FORMAT: vxxx.push(getContent(PatchNoteType.xxx, 'Description', ['Thanks to'], 'Before .png', 'After .png', ['FeatureUpvote link']))

        this.patchNotes.push(getPatchNote(2025, 12, 16, 283, v283))
    }

    getContributionCount(username: string): number {
        let count = 0
        for(const pn of this.getAll()) {
            for(const content of pn.contents) {
                for(const contributor of content.contributors) {
                    if(contributor == username) count += 1
                }
            }
        }
        return count
    }

    getAnnouncements(): string[] {
        return this.announcement
    }

    getAll(): PatchNote[] {
        return this.patchNotes
    }

    getLast5(): PatchNote[] {
        return this.patchNotes.slice(0, 5)
    }

    getLatest(): PatchNote[] {
        return this.patchNotes.slice(0, 1)
    }
}
